(function(){
  function pad(n){return String(n).padStart(2,'0');}
  function tick(el){
    var now = new Date();
    var end = new Date(now.getFullYear(), now.getMonth(), now.getDate()+1, 0,0,0,0);
    var diff = end - now;
    if (diff < 0) diff = 0;
    var h = Math.floor(diff/3600000);
    var m = Math.floor((diff%3600000)/60000);
    var s = Math.floor((diff%60000)/1000);
    el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  function init(){
    var els = document.querySelectorAll('[data-vx-deal-timer]');
    els.forEach(function(el){
      tick(el);
      setInterval(function(){ tick(el); }, 1000);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
